// extracted by mini-css-extract-plugin
export default {"tile-icon":"daily-specials--3wLNg","tile-icon--super-offer":"daily-specials--17tda"};